// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonPart_button__k3GkL"};